import React from "react"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import * as module1Style from "../styles.module.scss"

const ModuleType1 = ({ data }) => {
  return (
    <div className={module1Style.module1}>
      <div className={module1Style.greetingSection}>
        <h1 className={module1Style.introTitle}>{data.greetingText}</h1>
      </div>
      <div className={module1Style.caseStudySection}>
        <div className={module1Style.caseStudyTextBlock}>
          <div className={module1Style.caseStudyNameAndDescription}>
            <div className={module1Style.caseStudyTitleAndSubtitle}>
              <h3 className={module1Style.caseStudyTitle}>{data.title}</h3>
              <p className={module1Style.caseStudyCompany}>{data.subTitle}</p>
            </div>
            <p className={module1Style.caseStudyDescription}>
              {data.description.description}
            </p>
          </div>
        </div>
        {data.images &&
          data.images.map((item, idx) => {
            const image = getImage(item.image)
            return (
              <div className={module1Style.moduleImage} key={idx}>
                <GatsbyImage
                  key={item.image.id}
                  style={{
                    maxWidth: `${item.image.file.details.image.width}px`,
                    height: "auto",
                    margin: "0 auto",
                  }}
                  alt={item.image.title}
                  image={image}
                />
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default ModuleType1
